import { useState } from 'react';
import EfLink from '../ef-link';

export default function BuyLink({
    locale,
    prefixCls,
    item,
    buyInCartHandle,
    textA,
}: {
    locale: string;
    prefixCls: string;
    item: any;
    buyInCartHandle: any;
    textA: any;
}) {
    const inventoryQuantity2 = item.inventoryQuantity || 0; //主产品的剩余库存
    const [buyHref2, setBuyHref2] = useState(`https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`); //购买链接
    const buyText2 = item.buyText || textA.link_buy;

    return (
        <>
            {inventoryQuantity2 > 0 && !item.buyInCart && (
                <EfLink
                    className={`${prefixCls}-link ${prefixCls}-link-buy`}
                    href={buyHref2}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${buyText2}_${item?.name}`,
                    }}
                >
                    {buyText2}
                </EfLink>
            )}
            {inventoryQuantity2 > 0 && item.buyInCart && (
                <button className={`${prefixCls}-link ${prefixCls}-link-buy`} onClick={buyInCartHandle}>
                    {buyText2}
                </button>
            )}
            {inventoryQuantity2 === 0 && <span className={`${prefixCls}-link ${prefixCls}-link-buy ${prefixCls}-link-disabled`}>{textA.sold_out}</span>}
        </>
    );
}
